export default "__VITE_ASSET__c48e70b1__"